
import { Component, Vue } from "vue-property-decorator";

//子组件目录
import Comp0 from "./component-new-h5/comp0.vue"; //0123无实际顺序，仅作便捷区分  抬头
import Comp1 from "./component-new-h5/comp1.vue"; //个人总览
import Comp2 from "./component-new-h5/comp2.vue"; //ai总览
import Comp3 from "./component-new-h5/comp3.vue"; //ai维度分析
import Comp4 from "./component-new-h5/comp4.vue"; //英语水平
import Comp5 from "./component-new-h5/comp5.vue"; //普通话水平
import Comp6 from "./component-new-h5/comp6.vue"; //心理测评 dvf1.0
import Comp6inner1 from "./component-new-h5/comp6-1.vue"; //DISC性格测试
import Comp6inner2 from "./component-new-h5/comp6-2.vue"; //大五人格标准版 OCEAN人格评估
import Comp6inner3 from "./component-new-h5/comp6-3.vue"; //大五人格 60题
import Comp8 from "./component-new-h5/comp8.vue"; //回答记录
import Comp9 from "./component-new-h5/comp9.vue"; //作弊风险检测
import Comp11 from "./component-new-h5/comp11.vue"; //背景调查
import Comp12 from "./component-new-h5/comp12.vue"; //手部检测
import Comp13 from "./component-new-h5/comp13.vue"; //辩色检测
import Comp14 from "./component-new-h5/comp14.vue"; //电子签名
import Comp15 from "./component-new-h5/comp15.vue";
import Comp16 from "./component-new-h5/comp16.vue";
import Comp17 from "./component-new-h5/comp17.vue";
import Appendix from "./component-new-h5/appendix/index.vue"; // 阅读指引
import LowerRightCorner from "./component-new-h5/lower-right-corner/index.vue"; // 右下角功能按钮
import {
  CandidateNewResult,
  ReportShowConfigV5
} from "@/lib/model/exam/candidate-result";
import { debounce } from "lodash-es";

//more after today

@Component({
  components: {
    Comp0,
    Comp1,
    Comp2,
    Comp3,
    Comp4,
    Comp5,
    Comp6,
    Comp6inner1,
    Comp6inner2,
    Comp6inner3,
    Comp8,
    Comp9,
    Comp11,
    Comp12,
    Comp13,
    Comp14,
    Comp15,
    Comp16,
    Comp17,
    Appendix,
    LowerRightCorner
  }
})
export default class PaperResultReportH5 extends Vue {
  connectCode = "";
  dataAllReady = false;
  // candidate = new Candidate(); //候选人信息 主表
  all = new CandidateNewResult(); //候选人信息 所有表
  bigImgUrl = "";
  showBigImg = false;
  colorRes = { 0: "#5654DC", 1: "#19C976", 2: "#19C976", 3: "#19C976" };

  filterObj: {
    [K: string]: (all: CandidateNewResult, arg?: ReportShowConfigV5) => Boolean;
  } = {
    "DVF2.0心理健康测量": (all: CandidateNewResult) => {
      return !!all.report.tacPsycGaugeList.find(item => item.id === 1);
    },
    面试分析: (all: CandidateNewResult, item?: ReportShowConfigV5) => {
      return item?.versionId === 0
        ? !!all.report.dimensionGroupList.length
        : !!all.reportShowConfigV5.find(item => {
            const isInclude = [
              "手部综合检测",
              "辩色检测",
              "背景调查",
              "维度分析",
              "形体综合检测",
              "DVF1.0心理风险测量",
              "作弊风险检测"
            ].includes(item.name);
            if (isInclude) {
              return this.filterObj[item.name](all, item);
            }
          });
    },
    维度分析: (all: CandidateNewResult, item?: ReportShowConfigV5) => {
      return item?.versionId === 0
        ? !!all.report.dimensionGroupList.length
        : !!all.report.dimensionReportList.length;
    },
    普通话水平: (all: CandidateNewResult) =>
      !!all.report.chineseAssessmentResult._isAssignedFlag,
    英语口语水平: (all: CandidateNewResult) =>
      !!all.report.englishAssessmentResult._isAssignedFlag,
    DISC性格测试: (all: CandidateNewResult) =>
      !!all.report.tacPsycGaugeList.find(item => item.id === 2),
    大五人格标准版测试: (all: CandidateNewResult) =>
      !!all.report.tacPsycGaugeList.find(item => item.id === 5),
    大五人格核心版测试: (all: CandidateNewResult) =>
      !!all.report.tacPsycGaugeList.find(item => item.id === 4),
    作弊风险检测: (all: CandidateNewResult) => {
      // console.log('----------------------------------------')
      // console.log(this.all.report.errorInfoList)
      return !!all.report.errorInfoList.filter(item => {
        return [
          "livenessRecognition",
          "screenshotDetection",
          "mobileJoinCount",
          "replacementPerson",
          "jumpOutDetection",
          "faceShowDetection",
          "faceDetection",
          "readingDetection",
          "keyboardSoundDetection",
          "multiVoiceDetection"
        ].includes(item.task);
      }).length;
    },
    背景调查: (all: CandidateNewResult) => {
      const bgCheckList = all.report.errorInfoList.filter(item =>
        [
          "bgCheckIdentity",
          "bgCheckFinancial",
          "bgCheckSocial",
          "nameIdCheck"
        ].includes(item.task)
      );
      return !!bgCheckList.length;
    },
    手部综合检测: (all: CandidateNewResult) =>
      !!all.report.handDetection._isAssignedFlag,
    形体综合检测: (all: CandidateNewResult) =>
      !!all.report.bodyDetection._isAssignedFlag,
    辩色检测: (all: CandidateNewResult) =>
      !!all.report.colorDetection._isAssignedFlag,
    仪容仪表: (all: CandidateNewResult) =>
      !!all.report.hairDetection._isAssignedFlag ||
      !!all.report.dressingDetection._isAssignedFlag ||
      !!all.report.smokeDetection._isAssignedFlag,
    面部综合检测: (all: CandidateNewResult) =>
      !!all.report.faceDetection._isAssignedFlag,
    回答记录: (all: CandidateNewResult) => !!all.report.questionList.length,
    电子签名: (all: CandidateNewResult) =>
      !!all.report.signature._isAssignedFlag
  };

  get getCardSort() {
    const list = this.all.reportShowConfigV5;
    if (list.length < 2) return [];
    return list
      .filter((item: any) => !item.isHidden)
      .filter((item: any) => item.sort > 0)
      .filter(
        (item: any) => this.filterObj[item.name]?.(this.all, item) ?? true
      )
      .sort((a: any, b: any) => a.sort - b.sort);
  }

  debouncedHandleScroll: any;
  //
  async mounted() {
    const { tid, sid, connectCode } = this.$route.query as {
      tid: string;
      sid: string;
      connectCode: string;
    };
    this.connectCode = connectCode;
    CandidateNewResult.get({
      connectCode,
      tid,
      sid
    }).then((res: any) => {
      this.all = res;
      this.setCompany();
      this.loadPage();
      this.dataAllReady = true;
    });
  }

  loadPage() {
    this.debouncedHandleScroll = debounce(this.handleScroll, 100);
    document.body.addEventListener("scroll", this.debouncedHandleScroll);
  }

  openImg(url: string) {
    this.bigImgUrl = url;
    this.showBigImg = true;
  }

  setCompany() {
    const company = this.all.companyInfo;
    if (company.shortname) {
      document.title = "AI面试结果报告";
    }
    if (company.companyIcon) {
      let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
      if (!link) {
        link = document.createElement("link") as HTMLLinkElement;
      }
      if (link) {
        link.rel = "icon";
        link.href = company.companyIcon;
        document.head.appendChild(link);
      }
    }
  }

  beforeDestroy() {
    document.body.removeEventListener("scroll", this.debouncedHandleScroll);
  }

  getOptionModel(name: string) {
    return this.all.reportShowConfigV5.find((item: any) => item.name === name);
  }

  // 导航相关
  navFixed = false; //导航栏fixed
  currentItem = { name: "个人总览" };
  //最全情况
  navList = [
    { name: "个人总览" },
    { name: "维度分析" },
    { name: "DVF2.0心理健康测量" },
    { name: "回答记录" },
    { name: "作弊风险检测" },
    { name: "背景调查" },
    { name: "手部综合检测" },
    { name: "形体综合检测" },
    { name: "仪容仪表" },
    { name: "面部综合检测" },
    { name: "辩色检测" },
    { name: "报告阅读指引" },
    { name: "英语口语水平" }
  ];

  //实际用到
  get navItems() {
    const list = this.getCardSort.filter((item: any) => {
      const card = this.navList.find(nav => nav.name === item.name);
      if (!card) return false;
      if (item.name === "DVF2.0心理健康测量") {
        item.showName = "DVF心理测评";
      }
      return true;
    });

    return list;
  }
  navFixedHeight = 76; //fix的导航栏高度
  scrollToSection(item: any) {
    // this.$refs[item.name][0].$el.scrollIntoView({ behavior: "smooth" });
    const element = this.$refs[item.name][0].$el; // 获取目标元素
    const elementPosition = element.offsetTop; // 获取目标元素相对于视口的顶部位置
    const offset = this.navFixedHeight; // 设置偏移量为fix的导航栏高度
    const targetPosition = elementPosition - offset; // 计算目标滚动位置

    document.body.scrollTo({
      top: targetPosition,
      behavior: "smooth" // 设置滚动行为为平滑滚动
    });
    // this.currentItem = item;
  }
  handleScroll() {
    // 根据滚动位置更新currentItem来高亮导航项
    const scrollPosition = document.body.scrollTop + this.navFixedHeight;
    for (let item of this.navItems) {
      const ref = this.$refs?.[item.name]?.[0]?.$el;
      if (!ref) continue;
      if (
        scrollPosition >= ref.offsetTop &&
        scrollPosition < ref.offsetTop + ref.offsetHeight
      ) {
        this.currentItem = item;
        break; // 找到当前区域，退出循环
      }
    }
    // 当navbarChangeToFixedFlag在屏幕视口范围之上时，导航栏fixed
    const navbarChangeToFixedFlag = this.$refs[
      "navbarChangeToFixedFlag"
    ] as HTMLDivElement;
    if (!navbarChangeToFixedFlag) return;
    const top = navbarChangeToFixedFlag.getBoundingClientRect().top;
    this.navFixed = top < 0;
    // this.ensureVisible(); //这个实际效果有点慢，看看后续有啥好的方法
  }

  //检测当前高亮的导航项是否可见，不可见则滚动到可见位置
  ensureVisible() {
    this.$nextTick(() => {
      const activeItem = this.$refs["navItemActive"][0] as HTMLElement;
      if (activeItem && !this.isElementInViewport(activeItem)) {
        activeItem.scrollIntoView({
          behavior: "smooth",
          // block: "nearest",
          inline: "nearest"
        });
      }
    });
  }
  // 检查元素是否在视口内
  isElementInViewport(el: HTMLElement) {
    const rect = el.getBoundingClientRect();
    const parentRect = (el.parentNode as HTMLElement)?.getBoundingClientRect();
    return rect.left >= parentRect.left && rect.right <= parentRect.right;
  }

  //判断模块数据是否真实存在
  cheatList: any[] = [];
  getCheatList(list: any[]) {
    this.cheatList = list;
  }
  bgCheckList: any[] = [];
  getBgCheckList(list: any[]) {
    this.bgCheckList = list;
  }
  eyeCheckList: any[] = [];
  getEyeCheckList(list: any[]) {
    this.eyeCheckList = list;
  }
  fingerList: any[] = [];
  getFingerList(list: any[]) {
    this.fingerList = list;
  }
  navBg4 = require("./assets/nav-bg-4.png");
  navBg5 = require("./assets/nav-bg-5.png");
  navBg6 = require("./assets/nav-bg-6.png");
  navBg7 = require("./assets/nav-bg-7.png");
  //nav背景
  getNavBg(item: ReportShowConfigV5) {
    const min = 4;
    const max = 7;
    const length =
      item.name.length < min
        ? min
        : item.name.length > max
        ? max
        : item.name.length;
    const img = "navBg" + length;
    return `background:url(${this[img]}) no-repeat center/100% 100%`;
  }
  get showCompanyLogo() {
    return !this.getOptionModel("报告抬头")?.optionMap.hiddenCompanyLogo;
  }
}
